import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { getTemplate } from 'helpers/template-helper'
import merge from 'lodash/merge'

/**
 * Вид для уведомления.
 * @param {string} notificationInner Элемент уведомления.
 * @param {(number|null)} [timeToShow] Время показа уведомления. Если равно null, то не будет скрываться.
 * @param {(number|null)} [animationDuration] Скорость анимации.
 * @param {Function} handleRemove Обработчик удаления уведомления.
 */
@Defaults({
  events: {
    'click .js-remove-notification': 'removeNotification',
  },
  mouseEvents: {
    'mouseenter': 'clearTimeoutToRemove',
    'mouseleave': 'setTimeoutToRemove',
  },
  template: '#notification-template',
  additionalOptions: ['notificationInner', 'animationDuration', 'timeToShow', 'handleRemove'],
  timeoutToRemove: null,
  animationDuration: 300,
  timeToShow: 3000,
})
export class NotificationView extends View {
  /** @inheritDoc */
  run () {
    this.template = getTemplate(this.template)
  }

  /**
   * Рендер уведомления.
   * @param {jQuery} $placeHolder Элемент в который будет добавлено уведомление.
   * @param {boolean} withCross Признак отвечающий за рендер крестика.
   * @param {Object} events Объект с событиями и обработчиками.
   * @returns {NotificationView} Возвращает себя.
   */
  render ($placeHolder, withCross, events = null) {
    events && merge(this.events, events)
    this.timeToShow && merge(this.events, this.mouseEvents)
    this.setElement(
      $(this.template({
        notificationInner: this.notificationInner,
        withCross: withCross,
      }))
    )
    $placeHolder.append(this.$el)
    this.$el.slideToggle(
      this.animationDuration,
      () => this.timeToShow && this.setTimeoutToRemove()
    )
    return this
  }

  /**
   * Чистит таймер удаления уведомления.
   */
  clearTimeoutToRemove () {
    clearTimeout(this.timeoutToRemove)
    this.timeoutToRemove = null
  }

  /**
   * Запускает таймер удаления уведомления.
   */
  setTimeoutToRemove () {
    this.timeoutToRemove = setTimeout(() => this.removeNotification(), this.timeToShow)
  }

  /**
   * Удаляет уведомление
   */
  removeNotification () {
    this.timeoutToRemove && this.clearTimeoutToRemove()
    this.$el.slideToggle(
      this.animationDuration,
      () => {
        this.remove()
        this.handleRemove && this.handleRemove(this)
      }
    )
  }
}
